import { Action } from '@ngrx/store';

import { ActionWithPayload } from '../../shared/ngrx/action-with-payload.class';
import { WatchlistSnapshot } from '../model/watchlist-snapshot';


/**
 * Fetches a watchlist snapshot item
 */
export const FETCH_ITEM = '[WATCHLIST_SNAPSHOTS] Fetch item';
export class FetchItemAction implements ActionWithPayload<{uuid: string}> {
  readonly type = FETCH_ITEM;


  constructor(public payload: {uuid: string}) {}
}

/**
 * Fetch of a watchlist snapshot item succeeded, payload contains item
 */
export const FETCH_ITEM_SUCCEEDED = '[WATCHLIST_SNAPSHOTS] Fetch item succeeded';
export class FetchItemSucceededAction implements Action {
  readonly type = FETCH_ITEM_SUCCEEDED;


  constructor(public payload: {snapshot: WatchlistSnapshot; subSnapshots?: WatchlistSnapshot[]}) {}
}

/**
 * Fetch of a watchlist snapshot item failed, payload contains error
 */
export const FETCH_ITEM_FAILED = '[WATCHLIST_SNAPSHOTS] Fetch item failed';
export class FetchItemFailedAction implements ActionWithPayload<any> {
  readonly type = FETCH_ITEM_FAILED;


  constructor(public payload: any) {}
}

export type Actions = FetchItemAction
  | FetchItemSucceededAction
  | FetchItemFailedAction;
